export default __webpack_public_path__ + "static/media/glr-3.60264aa3.webp";